import { render } from "./BlogOverview.vue?vue&type=template&id=ddf9c37c&scoped=true"
import script from "./BlogOverview.vue?vue&type=script&lang=js"
export * from "./BlogOverview.vue?vue&type=script&lang=js"

import "./BlogOverview.vue?vue&type=style&index=0&id=ddf9c37c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf9c37c"]])

export default __exports__